import React, { useState } from "react";
import {
  Box,
  Card,
  CardContent,
  Collapse,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";

const LessonLocation = ({ location }) => {
  const [expanded, setExpanded] = useState(false);

  if (!location) return null;

  return (
    <Card elevation={0} sx={{ backgroundColor: '#f5f5f5', borderRadius: 2 }}>
      <CardContent sx={{ py: 1.5, '&:last-child': { pb: 1.5 } }}>
        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          onClick={() => setExpanded(!expanded)}
          sx={{ cursor: "pointer", userSelect: "none" }}
        >
          <Stack direction="row" spacing={1.5} alignItems="center">
            <Box sx={{ fontSize: '1.25rem' }}>📍</Box>
            <Typography variant="body2" fontWeight="500">
              Lokalizacja
            </Typography>
          </Stack>
          <IconButton size="small" sx={{ ml: 1 }}>
            {expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          </IconButton>
        </Box>

        <Collapse in={expanded}>
          <Box sx={{ mt: 1.5, ml: 4.5 }}>
            <Typography variant="body2" fontWeight="500">
              {location.name || 'Lokalizacja'}
            </Typography>
            {location.address && (
              <Typography variant="caption" color="text.secondary">
                {location.address}
              </Typography>
            )}
          </Box>
        </Collapse>
      </CardContent>
    </Card>
  );
};

export default LessonLocation;
